var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatasourceColumn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Column") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    fill: "#FFD300",
    transform: "translate(-48.000000, -108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Column",
    transform: "translate(48.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M6.56363636,1 L6.56363636,13 L1,13 L1,1 L6.56363636,1 Z M13,1 L13,13 L7.43636364,13 L7.43636364,1 L13,1 Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasourceColumn);
export default __webpack_public_path__ + "static/media/datasource-column.973d49763854414a7600c3a6ca8692a5.svg";
export { ForwardRef as ReactComponent };